module.exports = __webpack_public_path__ + "img/sign-name.bc55fd28.png";